import {map, xor, intersection} from 'lodash';
import {PureComponent} from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';

import {ConfirmModal, Checkbox} from 'components';
import {TRANSLATION_KEYS} from 'locale';

import {ModalResult, ReportColumn} from '../interfaces';

const T_KEYS = TRANSLATION_KEYS.USER.ACTIVITY.SESSION_HISTORY.EXPORT_MODAL;
const T_KEYS_COLUMNS = TRANSLATION_KEYS.USER.ACTIVITY.SESSION_HISTORY.DOWNLOAD_REPORT.COLUMNS;

type Props = {
    readonly open: boolean;
    readonly reportColumns: ReportColumn[];
    readonly onClose: (result?: ModalResult) => void;
} & WithTranslation;

type State = {
    selectedColumns: ReportColumn[];
}

const initialState: State = {
    selectedColumns: []
};

// TODO: re-implement with hooks
class ExportReportModal extends PureComponent<Props, Readonly<State>> {
    readonly state = initialState;

    get okDisabled() {
        return this.state.selectedColumns.length === 0;
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.open && !prevProps.open) {
            this.setState({
                selectedColumns: this.props.reportColumns
            });
        }
    }

    onModalClose = (confirm: boolean) => {
        if (confirm) {
            const {selectedColumns} = this.state;
            this.props.onClose({
                selectedColumns: intersection(this.props.reportColumns, selectedColumns),
            });
        } else {
            this.props.onClose(null);
        }
    };

    toggleColumn = (column: ReportColumn) => {
        this.setState({
            selectedColumns: xor(this.state.selectedColumns, [column])
        });
    };

    render() {
        const {t, open, reportColumns} = this.props;
        const {toggleColumn, okDisabled, onModalClose} = this;
        const {selectedColumns} = this.state;

        return (
            <ConfirmModal
                open={open}
                fullWidth
                maxWidth='sm'
                okDisabled={okDisabled}
                okText={t(T_KEYS.SUBMIT_BTN)}
                title={t(T_KEYS.TITLE)}
                onClose={onModalClose}
            >
                <div className='tw-text-default-dimmed tw-mt-4 tw-ml-2 tw-mb-2'>{t(T_KEYS.SELECT_COLUMNS)}</div>

                <div>
                    {map(reportColumns, (column) => (
                        <div key={column} className='tw-w-1/2 tw-my-2 tw-inline-block'>
                            <Checkbox
                                name={column}
                                size='small'
                                label={t(T_KEYS_COLUMNS[column])}
                                checked={selectedColumns.includes(column)}
                                inline
                                onChange={() => toggleColumn(column)}
                            />
                        </div>
                    ))}
                </div>
            </ConfirmModal>
        );
    }
}

export default withTranslation()(ExportReportModal);
